export default __webpack_public_path__ + "static/media/IMG_00008.1fb033e5.jpeg";